<template>
  <b-form-invalid-feedback :state="state" v-if="!state">
    <slot></slot>
  </b-form-invalid-feedback>
</template>

<script>
/**
 * This component wraps b-form-invalid-feedback so we can easily use it with Vuelidate,
 * by converting Vuelidate property into a Bootstrap Vue 'state' value
 */
import { get } from 'lodash'
export default {
  name: 'VuelidateInvalidFeedback',
  props: {
    // The vuelidate field to operate on
    field: Object,
    // The validation to check against
    validation: String
  },
  computed: {
    state () {
      const dirty = get(this.field, '$dirty')
      const validation = get(this.field, this.validation)

      // If field is dirty
      if (dirty === true) {
        // validation has succeeded
        if (validation === false) {
          return false
        }
        // validation has succeeded
        if (validation === true) {
          return true
        }
      }
      // Indeterminate result
      return null
    }
  }
}
</script>

<style scoped>

</style>
